import React from 'react';
import classNames from 'classnames';
import './address-field.scss';

class AddressField extends React.Component {
  componentDidMount() {
    const { index } = this.props;

    if (index === 0) {
      setTimeout(() => {
        document.getElementById('address-field-1').focus();
      }, 300);
    }
  }

  onClick = event => {
    this.props.handler(this.props.index, event);
  };

  onKeyPress = event => {
    if (event.key === 'Enter') {
      this.onClick(event);
    }
  };

  render() {
    const { text, isSelected, index } = this.props;
    const fieldsClass = classNames('address-field', { selected: isSelected });
    return (
      <div
        className={fieldsClass}
        onClick={this.onClick}
        key={index}
        onKeyUp={this.onKeyPress}
        id={`address-field-${index + 1}`}
      >
        <div className="radio-circle" role="none">
          <div></div>
        </div>
        <p>{text}</p>
      </div>
    );
  }
}
export default AddressField;
